<template>
	<div id="app" class="app">
		<!-- <router-view/> -->
		<keep-alive>
			<router-view v-if='$route.meta.keepAlive' />
		</keep-alive>
		<router-view v-if='!$route.meta.keepAlive' />
	</div>
</template>
<script>
	import { order } from "@/api"
	import { Toast } from 'vant';
	export default {

		name: 'App',
		watch: {
			$route(to, from) { }
		},

		mounted() {
			var that=this
			localStorage.removeItem('iscallin');
//			let root = document.querySelector(":root");
//			if(localStorage.getItem('color') == "#f39407") {
//				root.style.setProperty("--color", "#f39407");
//			} else {
//				root.style.setProperty("--color", "#f39407");
//			}
			var postcall=false
//			this.calling = setInterval(() => {
//				if(!postcall){
//					postcall=true
//					if(!localStorage.getItem('iscallin')) {
//						if(localStorage.getItem('token')) {
//							order.usercall(({})).then(ret => {
//								if(ret) {
//									postcall=false
//									if(ret.data.status == 1) {
//										let order = ret.data.data
//										localStorage.setItem('iscallin', true);
//										if(order.isgroup == 0) {
//											this.$router.push(
//												'/order/becall?channel=' +
//												order.order_sn + '&isgroup=0&uid=' +
//												order.uid + '&name=' + order.name +
//												'&portrait=' + order.portrait + '&doctorid=' +
//												order.doctorid + '&id=' + order.id + '&myself=' + order.myself
//											);
//										} else {
//											this.$router.push(
//												'/order/becall?channel=' +
//												order.order_sn + '&isgroup=1&uid=' +
//												order.uid + '&name=' + order.name +
//												'&portrait=' + order.portrait + '&doctorid=' +
//												order.doctorid + '&id=' + order.id + '&myself=' + order.myself
//											);
//										}
//									}else{
//										console.log('无信息')
//									}
//								}else{
//									postcall=false
//								}
//							}).catch((err) => {
//          					postcall=false
//							})
//						}else{
//							postcall=false
//						}
//					} else {
//						postcall=false
//						console.log('通话中')
//					}
//				}
//			}, 4000);
			
		},
		beforeDestroy() {
			clearInterval(this.calling);
		},
	}
</script>

<style>
	html {
		background: none !important;
		max-width: 100%;
		margin: 0 auto;
	}
	
	body {
		position: absolute;
		width: 100%;
		min-height: 100%;
	}
	
	#app {
		/*min-height: 100vh;*/
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		max-width: 100%;
	}
	
	.van-button__text {
		display: block;
		width: 100%;
		text-align: center;
	}
	
	.detail-box img {
		max-width: 100%;
		display: block;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue